<template>
  <div
    class="text-one-column"
    :class="classes"
  >
    <div class="text-one-column-richtext">
      <slot />
    </div>
    <KfButtonContainer
      :button-container-links="links"
      :button-container-position-horizontal="btnAlignmentHorizontal"
    />
  </div>
</template>

<script>
import KfButtonContainer from '@/components/button-container/ButtonContainer.vue';

export default {
  name: 'KfTextOneColumn',
  components: {
    KfButtonContainer,
  },
  props: {
    imageUrl: {
      type: String,
      default: () => '',
    },
    links: {
      type: Array,
      default: null,
    },
    alignment: {
      type: String,
      default: null,
    },
    btnAlignmentHorizontal: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    classes() {
      return {
        [`is-${this.alignment}-aligned`]: this.alignment,
      };
    },
  },
};
</script>

<style lang="postcss">
.text-one-column {
  @apply flex flex-col;

  &.is-center-aligned {
    @apply items-center;

    .richtext {
      @apply text-center;
    }
  }

  &.is-right-aligned {
    @apply items-end;

    .richtext {
      @apply text-right;
    }
  }

  &-richtext {
    @apply flex flex-col justify-center;

    .richtext {
      @apply mb-6;

      + .link {
        @apply mx-auto;
      }
    }

    + .link {
      @apply mx-auto;
    }
  }

  .richtext > *:last-child,
  .richtext > div > *:last-child {
    @apply mb-0;
  }
}
</style>
